import { Typography } from '@mui/material';
import { Card } from 'components';
import React, { useCallback, useEffect, useState } from 'react';
import DashboardServices from 'services/DashboardServices';
import IncidentTypeServices from 'services/IncidentTypeServices';
import { useTheme } from '@mui/material/styles';
const TypeCountsWithRank = ({filters}) => {
    const theme = useTheme();
    const [data, setData] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [incidentTypes, setIncidentTypes] = useState([]);

    const getIncidentTypesData = useCallback(async () => {
        setLoaded(false);
        const response = await IncidentTypeServices.get({});
        console.log("API Response: incident Types", response); // Log the response
        if (response.success) {
            setIncidentTypes(response.data.data);
        }
    }, []);

    useEffect(() => {
        getIncidentTypesData();
    }, [getIncidentTypesData]);

    const getData = useCallback(async () => {
        setLoaded(false);
        const response = await DashboardServices.getTypeCount(filters);
        console.log("API Response:", response); // Log the response
        if (response.success) {
            const formattedData = response.data;
            setData(formattedData);
            setLoaded(true);
        }
    }, [filters]);

    useEffect(() => {
        getData();
    }, [getData]);

    // Function to calculate clip-path dynamically
   /*  const calculateClipPath = (index, total) => {
        const topWidth = 40 + index * 85; // Adjust the increment as needed
        return `polygon(40px 0%, ${topWidth}px 0%, 100% 100%, 0% 100%)`;
    }; */
    // Combine and sort data by rank
    const combinedData = incidentTypes.map(type => {
        const countData = data.find(d => d.incident_type_id === type.id) || { count: 0 };
        return { ...type, count: countData.count };
    }).sort((a, b) => b.rank - a.rank);

    const colors = ['#d9534f','#ef6916', '#f0ad4e','#e0e415', '#5bc0de', '#428bca','#5cb85c','#a35cb8','#ca18bb','#d71573'];

    const containerStyle = {
        borderRadius: '8px',
    };

    return (
        <Card className="p-4 w-full" style={containerStyle}>
            <Typography variant='h6'>Incidents Types</Typography>
            <div className='mt-3'>
            <div className='w-full' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {loaded && combinedData.map((item, index) => (
                    <div className='w-full' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '70%' }}>
                            <div key={item.id} style={{
                                width: `${13 + (index * 90/combinedData.length)}%`, // Increase width for lower ranks
                                backgroundColor: colors[index % colors.length],
                                margin: '1px 0',
                                borderTopLeftRadius:'30px',
                                borderTopRightRadius:'30px',
                                padding: '10px',
                                textAlign: 'center',
                                //borderRadius: '0px',
                                color: 'white',
                                fontWeight: 'bold',
                                position: 'relative',
                                boxSizing: 'border-box',
                                borderLeft: 'solid transparent',
                                borderRight: 'solid transparent',
                               // clipPath: calculateClipPath(index, combinedData.length), // Apply dynamic clip-path
                                borderWidth: `0 ${index * 5}%`, // Adjust border width for triangle effect
                            }}>
                                <Typography variant='p'>{item.count}</Typography>
                            </div>


                        </div>
                        <div className='px-2' style={{ width: '30%' }}>
                            <Typography variant='h6' style={{ color: theme.palette.text.primary, whiteSpace: 'pre-line', fontSize:'14px'}}>{item.name}</Typography>
                        </div>
                    </div>
                ))}
            </div>
            </div>
        </Card>
    );
};

export default TypeCountsWithRank;